import React from 'react';
import Section from '@components/Section';

export default function Bio({ contact, underline = true }) {
  if (!contact) {
    return null;
  }

  const bio = contact.bio || '';
  const byline = contact.byline || '';

  if (bio.length === 0 && byline.length === 0) {
    return null;
  }

  let html = bio || byline;
  html = html.replace(/\<a/, '<a target="_blank"');
  html = html.replace(/\<\/?br>/g, '\n');

  return (
    <Section>
      <Section.Title underline={underline}>Bio</Section.Title>
      <div style={{ whiteSpace: 'pre-wrap' }}>{html}</div>
    </Section>
  );
}
